import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constants';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var GetPortfolioProfileListAction = function () {

}


GetPortfolioProfileListAction.prototype = {

	getPortfolioProfileList: function (data) {

		restClient.getPortfolioProfileList(data, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else{
					AppDispatcher.dispatch({
						actionType: Constant.PORTFOLIO_PROFILE_LIST,
						data: error
					});
				}
			} else {
				//response['status']= 200;
				AppDispatcher.dispatch({
					actionType: Constant.PORTFOLIO_PROFILE_LIST,
					data: response
				});
			}
		})
	}
}

export default new GetPortfolioProfileListAction();